/*------------------------------------------------
// File Name:PDM_BodyCheck_TaoCan.js
// File Description:PDM_BodyCheck_TaoCan store方法
// Author:zxl
// Create Time:2023/04/07 17:42:05
//------------------------------------------------*/

import {
    GetPDM_BodyCheck_TaoCanList,
    GetPDM_BodyCheck_TaoCanListByPage,
    GetPDM_BodyCheck_TaoCanEntity,
    CreatePDM_BodyCheck_TaoCanEntity,
    UpdatePDM_BodyCheck_TaoCanEntity,
    DeletePDM_BodyCheck_TaoCanEntity,
} from '@/api/pdm/bodycheckTaocan'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmBodycheckTaocan = {
    namespaced: true,
    state: {
        PdmBodycheckTaocanList: [],
        PdmBodycheckTaocanListLoading: false,
        PdmBodycheckTaocanEntity: null,
        PdmBodycheckTaocanShowDlg: false,
        PdmBodycheckTaocanShowDlg2: false,
		TaocanTagsShowDlg: false,
		TaocanItemShowDlg: false,
    },
    mutations: {
        setPdmBodycheckTaocanList(state, dataList) {
            state.PdmBodycheckTaocanList = [...dataList]
        },
        setPdmBodycheckTaocanListLoading(state, visible) {
            state.PdmBodycheckTaocanListLoading = visible
        },
        setPdmBodycheckTaocanShowDlg(state, visible) {
            state.PdmBodycheckTaocanShowDlg = visible
        },
        setPdmBodycheckTaocanShowDlg2(state, visible) {
            state.PdmBodycheckTaocanShowDlg2 = visible
        },
		setTaocanTagsShowDlg(state, visible) {
            state.TaocanTagsShowDlg = visible
        },
		setTaocanItemShowDlg(state, visible) {
            state.TaocanItemShowDlg = visible
        },
        setPdmBodycheckTaocanEntity(state, entity) {
            state.PdmBodycheckTaocanEntity = entity
        },
    },
    actions: {
        //创建套餐表对象
        actCreatePdmBodycheckTaocan({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_BodyCheck_TaoCanEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckTaocanEntity', res.Data)
                        commit('setPdmBodycheckTaocanShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载套餐表对象
        actGetPdmBodycheckTaocanEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckTaocanListLoading', true)
                GetPDM_BodyCheck_TaoCanEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckTaocanEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckTaocanListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载套餐表列表
        actGetPdmBodycheckTaocanList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckTaocanListLoading', true)
                GetPDM_BodyCheck_TaoCanList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckTaocanList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckTaocanListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载套餐表列表
        actGetPdmBodycheckTaocanListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckTaocanListLoading', true)
                GetPDM_BodyCheck_TaoCanListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckTaocanList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckTaocanListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存套餐表信息
        actUpdatePdmBodycheckTaocan({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_BodyCheck_TaoCanEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckTaocanShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BodyCheck_TaoCan
        actEditPdmBodycheckTaocanData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmBodycheckTaocanID : entity.PdmBodycheckTaocanID
                }
                GetPDM_BodyCheck_TaoCanEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmBodycheckTaocanEntity', res.Data)
                        commit('setPdmBodycheckTaocanShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BodyCheck_TaoCan ,传对象过来
        actEditPdmBodycheckTaocan({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmBodycheckTaocanEntity', entity)
                commit('setPdmBodycheckTaocanShowDlg2', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_BodyCheck_TaoCan
        actDeletePdmBodycheckTaocan({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前套餐表？").onOk(() => {
                    DeletePDM_BodyCheck_TaoCanEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmBodycheckTaocanShowDlg', false)
                           
                            msg.success("删除套餐表成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除套餐表失败，原因:" + res.Message)
                            //msg.success("删除套餐表失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


